import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ActionRow = styled.div`
  display: flex;
  justify-content: end;
  gap: ${spacing('sm')};
`;

export const $Didactic = styled.div`
  margin-bottom: ${spacing('lg')};
`;
